import { Component, OnInit } from '@angular/core';
import {DoraRowsPreselectComponent} from '../dora-rows-preselect.component';
import {DataRow} from '../../../DoraData/data-row';
import {DataTupla} from '../../../DoraData/data-tupla';

@Component({
  selector: 'dora-rows-preselect-lb',
  templateUrl: './dora-rows-preselect-lb.component.html',
  styleUrls: ['./dora-rows-preselect-lb.component.scss']
})
export class DoraRowsPreselectLbComponent extends DoraRowsPreselectComponent {

  public selectedItem: Array<any> = [];

  // GridList
  public gridList: Array<any> = [];
  /**
   * Received new data
   */

  protected onNewData(): void {
    super.onNewData();

    // empty list
    this.gridList = [];
    this.selectedItem = [];

    // @ts-ignore
    for (const dataRow: DataRow of this.dataGrid.DataRows) {
      const descriptionTupla: DataTupla = dataRow.getDataTupla('Description');

      if (descriptionTupla !== undefined) {
        // get id
        // tslint:disable-next-line:max-line-length
        const selectElement = {id: dataRow.Id, text: `<div class="DAG-img-select" style="width: 10px; height: 10px; display: inline-block;"></div>${(descriptionTupla.Value as string)}`};
        this.gridList.push(selectElement);

        if (dataRow.selected) {
          this.selectedItem.push(selectElement);
        }
      }
    }
  }
  public selected(value: any): void {
    console.log('Selected value is: ', value);
    this.selectedGrid(value.id);
  }

}
